import {actionHistoryType} from "./Type";

export const changeCurrentUrl = (urlHistory) => ({
    type: actionHistoryType.CHANGE_CURRENT_URL,
    urlHistory
})

export const changeCurrentTab = (currentTab) => ({
    type: actionHistoryType.CHANGE_CURRENT_TAB,
    currentTab
})

export const changeCurrentAction = (url, tab) => ({
    type: actionHistoryType.CHANGE_CURRENT_ACTION,
    url,
    tab
})
export const changeUnloadActionHistory = (params) => ({
    type: actionHistoryType.CHANGE_UNLOAD_ACTION_HISTORY,
    params
})

export const onChangeForbidden = (params) => ({
    type: actionHistoryType.CHANGE_FORBIDDEN,
    params
})